<div class="container">
  <div class="filter-container">
    <div class="autocomplete-container">
      <app-autocomplete
      value="name"
      placeholder="Buscar"
      [formControl]="auto"
      height="36px"
      ></app-autocomplete>
      <app-tour-card 
        *ngIf="step === 1" 
        class="step1-card" 
        [currentStep]="step"
        [totalSteps]="totalSteps"
        [text]="firstText"
        (quit)="skipTour()"
        (next)="nextStep(null)"
        actionMsg="Clique para o próximo"></app-tour-card>
        <app-tour-card 
        *ngIf="step === 5" 
        class="step1-card" 
        [currentStep]="step"
        [totalSteps]="totalSteps"
        [text]="fifthText"
        (quit)="skipTour()"
        (next)="nextStep(null)"
        actionMsg="Concluir"></app-tour-card>
      <div *ngIf="step === 2" class="dropdown-container">
        <div class="dropdown-row" *ngFor="let opt of autocompleteOptions; let i = index" >
          <div id="facs-tour-autocomplete-option-{{i}}"
           (click)="nextStep(i)" [ngClass]="{'surround': i === 2}" [innerHTML]="opt.type + ': ' + opt.name"></div>
        </div>
      </div>
      <app-tour-card
        *ngIf="step === 2"
        class="step2-card"
        [currentStep]="step"
        [totalSteps]="totalSteps"
        (quit)="skipTour()"
        [text]="secondText"></app-tour-card>
    </div>
    <div class="btn-container">
      <button id="dnd-filter-btn" class="btn-filter">
        <img src="../../assets/svgs/funnel.svg" alt="Funnel Inativo" >
      </button>
      <button id="dnd-display-mode-btn" class="btn-filter" >
        <img src="../../assets/svgs/i_open_active.svg" alt="Lista Ativa">
      </button>
      <lib-button-secondary class="new-fac-btn">Cadastrar fac</lib-button-secondary>
      <lib-button-tertiary class="new-fac-btn-mobile">Cadastrar fac</lib-button-tertiary>
    </div>
  </div>

  <div class="tags-container">
    <ul class="tags-list" *ngIf="tags.length">
      <li class="tags-item" *ngFor="let tag of tags; let i = index">
        <a class="tags-action" id="tags-{{tag.name}}">
          <p>{{ tag.type }}: {{ tag.description }}</p>
          <button id="remove-tag-btn-{{i}}" class="btn-clear-tag">
            <img src="../../assets/svgs/i_clear.svg" alt="Deletar tag">
          </button>
        </a>
      </li>
    </ul>
    <app-tour-card
    *ngIf="step === 3"
    class="step3-4-card"
    [currentStep]="step"
    [totalSteps]="totalSteps"
    [text]="thirdText"
    (next)="nextStep(null)"
    (quit)="skipTour()"
    actionMsg="Clique para o próximo"></app-tour-card>
    <app-tour-card
    *ngIf="step === 4"
    class="step3-4-card"
    [currentStep]="step"
    [totalSteps]="totalSteps"
    [text]="fourthText"
    (quit)="skipTour()"
    (next)="nextStep(null)"
    actionMsg="Clique para o próximo"></app-tour-card>
  </div>

  <div class="dnd-template">
    <div class="ml"></div>
    <div class="dnd-container" *ngFor="let list of facsList">
      <div class="dnd-title" [ngClass]="{'dtd': list.title === 'Sem Atendimento'}">
        <p *ngIf="list.title.length">{{ list.title }} ({{ list.facs.length }})</p>
      </div>
      <div
        cdkDropList
        class="dnd-list"
        [ngClass]="{'dnd-dot': list.title === 'Sem Atendimento'}">
        <app-dnd-card
          class="dnd-box"
          *ngFor="let item of list.facs"
          [item]="item"
        ></app-dnd-card>
      </div>
    </div>
    <div class="mr"></div>
  </div>
</div>
<div class="backdrop-container" *ngIf="step === 6">
  <div class="modal-container">
    <div class="top-lane">
      <img class="lamp" src="../../../assets/svgs/lamp.svg" alt="lamp">
    </div>
    <div class="bottom-lane">
      <span class="title-text">Parabéns</span>
      <span class="message">Agora você poderá aproveitar ao máximo a busca de facs</span>
      <lib-button-primary id="end-facs-tour" (click)="nextStep(null)">Concluir</lib-button-primary>
    </div>
  </div>
</div>

<div class="backdrop-container" *ngIf="step === 0">
  <div class="modal-container">
    <div class="top-lane">
      <img class="sketch" src="../../../assets/svgs/system_sketch.svg" alt="lamp">
    </div>
    <div class="bottom-lane start">
      <span class="title-text">Busca de facs</span>
      <span class="message">Faça um tour guiado e veja como utilizar a poderosa ferramenta de busca para que você possa gerenciar suas facs com mais eficiência</span>
      <lib-button-primary id="start-facs-tour" (click)="nextStep(null)">Iniciar demonstração</lib-button-primary>
      <lib-button-tertiary id="skip-facs-tour" (click)="skipTour()">Pular</lib-button-tertiary>
    </div>
  </div>
</div>
